module.exports = __webpack_public_path__ + "img/first-block-bg.056abc17.jpg";